var $ = require('jquery');

var $toggle;
var getKling = function() {
    return localStorage.getItem('kling') == 'true';
};

var setKling = function(value) {
    var storeValue = !!value ? 'true':'false';
    try {
        localStorage['kling'] = storeValue;
        return !!value;
    } catch(Exception) {
        // Private browsing can cause an error.
        return false;
    }
};

var updateKlingBtn = function() {
  $toggle = $('.toggle-audio');
  if (!Modernizr.localstorage) {
      $toggle.attr('disabled', 'disabled');
      return;
  }

  // Kling is on by default
  if (localStorage.getItem('kling') === null ) {
      setKling(true);
  }

  if (getKling()) {
      $toggle.addClass('active');
  }

  $toggle.on('click', function() {
      var active = setKling(!$toggle.hasClass('active'));
      $toggle.toggleClass('active', active);
  });
}

$(function(){
    updateKlingBtn();
});

module.exports = updateKlingBtn;



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/kling.js
// module id = 24
// module chunks = 0